import { render, staticRenderFns } from "./BlockType2Grid.vue?vue&type=template&id=109234c2&scoped=true&"
import script from "./BlockType2Grid.vue?vue&type=script&lang=ts&"
export * from "./BlockType2Grid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType2Grid.vue?vue&type=style&index=0&id=109234c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109234c2",
  null
  
)

export default component.exports